import { ComponentProps } from "react";
import {
  BackButtonContent,
  BackButtonContentProps,
  Container,
  Expander,
  Icon,
  Text,
  text,
} from "./BackButton.Parts";

export const BackButton = ({
  label,
  ...props
}: Omit<ComponentProps<"button">, "disabled"> & BackButtonContentProps) => {
  return (
    <Container>
      <Expander>
        <BackButtonContent type="button" {...props}>
          <Icon />
          <Text variant="small">{label || text.label}</Text>
        </BackButtonContent>
      </Expander>
    </Container>
  );
};
